import checkIcon from "./images/icon-check.svg";
import deleteIcon from "./images/icon-cross.svg";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
function TaskList({ opacity, task, deleteTask, toggleDone }) {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: task.id });
  const style = {
    opacity: isDragging ? "0" : "1",
    transform: CSS.Translate.toString(transform),
    transition: transition + ", background-color 0.3s",
  };
  return (
    <li style={style} ref={setNodeRef} className="item-box">
      <div className="item-left">
        <div
          onClick={() => toggleDone(task.index)}
          className={"check-circle"}
          style={
            task.done
              ? {
                  background:
                    "linear-gradient(135deg, hsl(192, 100%, 67%), hsl(280, 87%, 65%))",
                }
              : null
          }
        >
          {task.done ? (
            <img src={checkIcon} alt="check"></img>
          ) : (
            <div className="undone"></div>
          )}
        </div>
        <p {...listeners} {...attributes} className="item-name">
          {task.name}
        </p>
      </div>

      <img
        src={deleteIcon}
        alt="delete"
        className="delete-item"
        onClick={() => deleteTask(task.index)}
      ></img>
    </li>
  );
}
export default TaskList;
